
import { MapLocation } from '@/types/location';

// Legend Ladies Gym Locations
export const legendLadiesGyms: MapLocation[] = [
  {
    id: 12001,
    name: "Legend Ladies Gym - Jeddah (Al Naseem)",
    type: "Gym",
    devices: 5,
    coordinates: [21.52036620857404, 39.234103864417655],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-45",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
